import type React from "react";
import { useId } from "react";
import { useTranslation } from "react-i18next";

import type { CountryCode } from "@krea/shared/types/common";

import { TextInput } from "../TextInput";

interface IPhoneInputProps {
  value: string;
  countryCode: CountryCode;
  touched: boolean;
  error?: string;
  label?: string;
  placeholder?: string;
  id?: string;
  onBlur?: () => void;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  dataTestId?: string;
}

export const PhoneInput = ({
  value,
  countryCode,
  touched,
  error,
  label,
  placeholder,
  id,
  onBlur,
  onChange,
  dataTestId,
}: IPhoneInputProps) => {
  const { t } = useTranslation("formFields");
  const generatedId = useId();

  const defaultPlaceholder =
    (
      t("formFields.phonePlaceholder", {
        returnObjects: true,
      }) as Record<string, string>
    )[countryCode] ?? "";

  return (
    <TextInput
      id={id ?? generatedId}
      name="mobile_phone_number"
      type="tel"
      dataTestId={dataTestId}
      label={label ?? t("formFields.phoneLabel")}
      placeholder={placeholder ?? defaultPlaceholder}
      autoComplete="on"
      value={value ?? ""}
      error={touched && error ? error : undefined}
      onChange={onChange}
      onBlur={onBlur}
    />
  );
};
